<template>
    <div class="national">
        <tournaments></tournaments>
        <activeList></activeList>
        <month ref="month" :monthActivityData="monthActivityData" :timeData="timeData" @changeMonth="activityMonth"></month>
        <div class="competition">
            <level ref="level" class="item"></level>
            <recommend v-if="recommendActivity" :recommendActivity="recommendActivity" class="item recommend"></recommend>
            <proportion ref="proportion" class="item proportion"></proportion>
        </div>
        <div class="competition">
            <trend class="item"></trend>
            <brand ref="brand" class="item brand proportion recommend"></brand>
            <activity ref="activity" class="item proportion"></activity>
        </div>
        <user></user>
    </div>
</template>

<script>
import tournaments from './components/tournaments'
import activeList from './components/activeList'
import month from './components/month'
import level from './components/level'
import recommend from './components/recommend'
import proportion from './components/proportion'
import trend from './components/trend'
import brand from './components/brand'
import activity from './components/activity'
import user from './components/user'
import bigData from '@/services/bigData'
export default {
    components: {
        tournaments, activeList, month, level, recommend, proportion, trend, brand, activity, user
    },
    data() {
        return {
            monthActivityData: [],
            recommendActivity: [],
            timeData: []
        }
    },
    created() {
        this.getMonth()
        this.getMonthActivity()
    },
    methods: {
        getMonthActivity() {
            bigData.monthActivity().then(res => {
                this.$refs.level.set(res.result.raceChartList)
                this.$refs.proportion.set(res.result.dance)
                this.$refs.brand.getData(res.result.bestBrand)
                this.$refs.activity.getData(res.result.bestActivity)
                this.recommendActivity = res.result.recommendActivity

            })
        },
        hanleMonthData(data) {
            this.monthActivityData = [data.allRaceActivityTotal, data.joinRaceTotal, data.exposureRaceTotal, data.maxDayActivityCount, data.maxProvinceActivityName]
        },
        getMonth(state = false) {
            let date = new Date()
            let years = date.getFullYear()
            let month = date.getMonth() + 1;
            years = month == 12 && state ? years + 1 : years;
            month = month == 12 && state ? 1 : state ? month + 1 : month;
            for(let i = 0; i < 6; i++) {
                month = month > 9 ? month : `0${month}`
                this.timeData.push({
                    key: `${years}-${month}-01`,
                    value: `${years}年${month}月赛事数据`
                })
                month--;
                if(month <= 0) {
                    month = 12;
                    years--;
                }
            }
            this.$nextTick(() => {
                this.$refs.month.time = this.timeData[0].key
            })
            this.activityMonth(this.timeData[0].key)
        },
        activityMonth(data) {
            bigData.activityMonth({ currentDateTime: data }).then(res => {
                this.hanleMonthData(res.result)
            })
        }
    },
}
</script>

<style lang="scss" scoped>
.national{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    min-width: 1200px;
    overflow-x: auto;
    height: 100%;
    background-color: #222236;
    padding: 24px;
    box-sizing: border-box;
    overflow-y: auto;
}
.competition{
    overflow: hidden;
    display: flex;
    .item{
        float: left;
    }
    .proportion{
        flex: 1;
    }
    .recommend{
        margin: 0 15px;
    }
}
</style>
